import {
  deleteAvatarApiV1UsersMeAvatarDelete,
  getMyProfileApiV1UsersMeGet,
  getMySessionsApiV1UsersMeSessionsGet,
  revokeAllSessionsApiV1UsersMeSessionsDelete,
  revokeSessionApiV1UsersMeSessionsSessionIdDelete,
  updateMyProfileApiV1UsersMePut,
  uploadAvatarApiV1UsersMeAvatarPost,
} from "@/backend-sdk/client/sdk.gen";
import type {
  ProfileResponse,
  UpdateProfileRequest,
  UploadAvatarResponse,
  UserSession,
} from "@/backend-sdk/client/types.gen";

type SessionInfo = UserSession;
export type { ProfileResponse };

class UserService {
  // Obter perfil do usuário atual
  async getMyProfile(): Promise<ProfileResponse> {
    const { data } = await getMyProfileApiV1UsersMeGet({
      throwOnError: true,
    });
    return data;
  }

  // Atualizar perfil
  async updateProfile(
    data: UpdateProfileRequest,
    customer_uuid?: string | null,
  ): Promise<ProfileResponse> {
    const { data: response } = await updateMyProfileApiV1UsersMePut({
      body: data,
      query: customer_uuid ? { customer_uuid } : undefined,
      throwOnError: true,
    });
    return response;
  }

  // Upload de avatar
  async uploadAvatar(file: File): Promise<UploadAvatarResponse> {
    const { data } = await uploadAvatarApiV1UsersMeAvatarPost({
      body: { file },
      throwOnError: true,
    });
    return data;
  }

  // Deletar avatar
  async deleteAvatar(): Promise<void> {
    await deleteAvatarApiV1UsersMeAvatarDelete({ throwOnError: true });
  }

  // Obter sessões ativas
  async getMySessions(): Promise<{ sessions: SessionInfo[] }> {
    const { data } = await getMySessionsApiV1UsersMeSessionsGet({
      throwOnError: true,
    });
    return data;
  }

  // Revogar sessão específica
  async revokeSession(sessionId: string): Promise<void> {
    await revokeSessionApiV1UsersMeSessionsSessionIdDelete({
      path: { session_id: sessionId },
      throwOnError: true,
    });
  }

  // Revogar todas as sessões
  async revokeAllSessions(): Promise<void> {
    await revokeAllSessionsApiV1UsersMeSessionsDelete({ throwOnError: true });
  }
}

export default new UserService();
